/* import external modules */
import React, { useEffect, useState } from 'react'
import { Col } from 'styled-bootstrap-grid'

/* import internal modules */
import Img from '../Common/Img'
import P from '../Common/P'
import { FeaturesContainer, Row } from './styles'
import useCustomerRoutes from '../../constants/routes'
import cname from '../../constants/classNameData'
import ButtonPrimaryMd from '../Common/ButtonPrimaryMd'
import NewCard from '../Common/Card'

/** @description This is a functional component of of page without campaigns
 *  @version 1.0.0
 *  @since 12/11/2020
 *  @author Elizabeth Velásquez <elivel@eltiempo.com>
 *
 *  @function
 *  @name WithoutCampaigns
 *  @returns {JSX.Element} Returns to information when there are no campaigns, and the button publish ad
 **/

const WithoutCampaigns = () => {
  const [url, setUrl] = useState('')
  const routes = useCustomerRoutes(url)

  const redirectBuyAds = () => window.open(routes.customersStartCampaignPage)
  const redirectBuyCondolence = () => window.open(routes.customersStartCondolencePage)

  useEffect(() => {
    const location = window.location.origin
    setUrl(location)
  }, [])

  return (
    <>
      <P color="#323334"
        font="800 32px/24px'Open Sans'"
        fontSm="800 24px/28px'Open Sans'"
        p="50px 0 50px 0"
        pSm="20px 0 45px 0"> Bienvenido </P>
      <P color="#444444"
        font="20px/28px'Open Sans'"
        fontSm="16px/24px'Open Sans'"
        style={{ textAlign: "justify" }}

        > Al adquirir alguno de nuestros productos podrás administrar tus servicios  de EL TIEMPO ADS y Condolencias EL TIEMPO</P>
        <FeaturesContainer>

          <NewCard titleText={"¡Haz que tu marca sea imparable!"}
            descriptionText={"EL TIEMPO ADS te conecta con una audiencia de alto valor"}
            textButton={"Crea tu campaña"}
            onClick={redirectBuyAds}
            image={"/images/computer.svg"}
            widthImage={"30%"}
          />
          <NewCard titleText={"¡Deja un mensaje de aliento!"}
            descriptionText={"Publica tu condolencia y lleva tu mensaje a quienes lo necesitan."}
            textButton={"Crea tu mensaje"}
            onClick={redirectBuyCondolence}
            image={"/images/newspaper.svg"}

          /> </FeaturesContainer>

        {/* <Col col>
          <Img
            icon="/images/without-campaigns-image.svg"
            alt="Imagen sin campañas"
          />
          <P font="24px/32px 'DMSans-Regular'" pt="24px">
            No tienes campañas en este momento
          </P>
          <P font="16px/24px'DMSans-Regular'" p="15px 0 25px 0">
            Publica nuevos anuncios y da a conocer tus productos y servicios de
            manera efectiva
          </P>
          <ButtonPrimaryMd
            name="publish-button"
            text="Crear campaña"
            classt={cname.first_button_bell}
            height="40px"
            onClick={redirectBuy}
          />
        </Col> */}
    </>
  )
}

export default WithoutCampaigns
